namespace app.quickPanel.notification {
    "use strict";
    
    import INotification = app.notification.INotification;

    export class FeedController {
        
        public feed: IFeedItem[] = [];
		
		public usersNames:Map = new Map();
        
        static $inject = ["$scope", "app.quick-panel.FeedService"];
        
        public constructor(private $scope: ng.IScope,
                           private feedService: FeedService) {
            feedService.list().then((feed) => {
                this.feed = feed;
				this.loadUsersNames(this.feed);
            });
            
            $scope.$on("feed", (event: ng.IAngularEvent, notification: INotification) => {
				let newFeed = this.feedService.toFeedItem(notification);
                this.feed.unshift(newFeed);
				this.loadUsersNames([newFeed]);
            });
            
            $scope.$on('feed:readed', (event: ng.IAngularEvent) => {
                this.feedService.read(this.feed);
            });
        }
        
        public remove(item: IFeedItem): void {
            this.feedService.remove(item.uuid)
                .then(() => {
                    this.feed.splice(this.feed.findIndex((i) => i.uuid === item.uuid), 1); 
                });
        }
        
        public removeAll(): void {
            this.feedService.removeAll()
                .then(() => {
                    this.feed = [];
                });
        }
        
        public loadMore(): void {
            this.feedService.list().then((feed) => {
                this.feed = feed;
				this.loadUsersNames(this.feed);
            });
        }
		
		private loadUsersNames(itens: IFeedItem[]): void {
			let usuarios = new Set();		
			itens.forEach((item) => {
				if (item.sender && !this.usersNames.has(item.sender.toLowerCase())) usuarios.add(item.sender.toLowerCase());
            });
			if (usuarios && usuarios.size > 0) {
				this.feedService.getNomeApresentacao(Array.from(usuarios)).then(resultado => {
                    for (const [login, nome] of Object.entries(resultado)) {
                        this.usersNames.set(login, nome);
                    }
				});
			}
		}
    }
    
    angular
        .module("app.quick-panel")
        .controller("app.quick-panel.FeedController", FeedController);
    
}